
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-48066338&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Trainings.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Trainings.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-48066338!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Trainings.vue"),
  /* scopeId */
  "data-v-48066338",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Trainings/Trainings.vue
// module id = 664
// module chunks = 0